



























import { FormRow } from '../../../models/Form';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TextField extends Vue {
  @Prop({ type: Object, required: true }) row!: FormRow;
  @Prop({ type: String }) tip!: string;
  @Prop({ type: Function }) onClick!: Function;
  @Prop({ type: Boolean, default: false }) isDisabled!: boolean;
  @Prop({ type: Boolean }) isComponentError!: boolean;

  handleClick() {
    if (this.onClick) {
      this.onClick(this.tip); 
    }
  }
}
